import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Box, useTheme } from '@mui/material';

import { styles } from './styles';
import AppBar from '@components/common/AppBar';
import { Modals } from '@core/Modal';
import { registeredModals } from '@components/modals/registeredModals';
import SuspenseLoading from '@components/common/SuspenseLoading';
import { useCurrentDataset } from '../../hooks/useCurrentDataset';
import History from '@components/icons/History';
import StoryGuidanceDrawer from '@components/drawers/StoryGuidanceDrawer';
import CreateNewStory from '@components/common/CreateNewStory';

export type StoryLayoutProps = {};

const StoryLayout: React.FC<StoryLayoutProps> = () => {
  const theme = useTheme();
  useCurrentDataset();

  return (
    <Box sx={styles.root}>
      <AppBar
        buttonProps={{
          icon: (
            <History
              sx={{ fontSize: '20px' }}
              htmlColor={theme.palette.common.surface['surface 47']}
            />
          ),
          onClick: () => {},
          label: 'History',
        }}
        drawerContent={StoryGuidanceDrawer}
        rightAdditionalContent={CreateNewStory}
      />
      <Modals registeredModals={registeredModals} />
      <Suspense fallback={<SuspenseLoading />}>
        <Box sx={styles.wrapper}>
          <Outlet />
        </Box>
      </Suspense>
    </Box>
  );
};

export default StoryLayout;
